export const MODULEMAP = {
    tradeledger: "trades"
};

export function lookupModule(module) {
    const result = MODULEMAP[module];
    return result ? result : module;
}